import { render, staticRenderFns } from "./inTheDepartment.vue?vue&type=template&id=90c4dd34&scoped=true&"
import script from "./inTheDepartment.vue?vue&type=script&lang=js&"
export * from "./inTheDepartment.vue?vue&type=script&lang=js&"
import style0 from "./inTheDepartment.vue?vue&type=style&index=0&id=90c4dd34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c4dd34",
  null
  
)

export default component.exports